import { render, staticRenderFns } from "./topicList.vue?vue&type=template&id=56cfe422&scoped=true"
import script from "./topicList.vue?vue&type=script&lang=js"
export * from "./topicList.vue?vue&type=script&lang=js"
import style0 from "./topicList.vue?vue&type=style&index=0&id=56cfe422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cfe422",
  null
  
)

export default component.exports